module.exports = __webpack_public_path__ + "static/media/app-logo.de9420be.png";